import isArray from "lodash/isArray";

export const APP_AUTH_USER = "persist:userInfo";
export const APP_AUTH_ACCESS_KEY = "access_token";
export const APP_AUTH_REFRESH_KEY = "refresh_token";

export const BASE_API_URL = process.env.REACT_APP_BACKEND_API;

export const REACT_APP_S3_BASE_URL = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const REACT_APP_UPLOADS_BASE_URL = BASE_API_URL

export const APP_NAME = "Blanca Admin";
export const CATRGORIES_NAME = "Categories";
export const UPLOAD_WAIT_MESSAGE =
  "Please wait for the image to finish uploading";

export const paid_status_list = ["freetrial", "free", "freemium", "paid"];

export const PROJECT_STATUS_LIST = [
  { value: "new-launches", label: "New Launch" },
  { value: "coming-soon", label: "Coming Soon" },
  { value: "on-going", label: "Ongoing" },
  { value: "sold-out", label: "Sold Out" },
  // { value: "completed", label: "Completed" },
] as const;

export const acceptExtensions = {
  "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp"],
  "video/mp4": [],
  "video/quicktime": [".mov"],
  "video/webm": [],
};

export const acceptDocExtensions = {
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    ".pptx",
  ],
};

export const acceptVideoExtensions = {
  "video/mp4": [],
  "video/quicktime": [".mov"],
  "video/webm": [],
};

export const profileImgExtensions = {
  "image/*": [".png", ".jpg", ".jpeg"],
};

export const acceptedFaviconExtensions = {
  "image/png": [],
  "image/svg+xml": [],
  "image/x-icon": [],
};

export const acceptImgExtensions = {
  "image/jpeg": [],
  "image/png": [],
  "image/webp": [],
  "image/jpg": [],
  "image/svg+xml": [],
};

export const removeBaseUrl = (
  imageUrl: string | undefined | null
): string | undefined => {
  if (!imageUrl) return imageUrl || "";
  const baseUrl = `${REACT_APP_UPLOADS_BASE_URL}/`;
  const regex = new RegExp(`^${baseUrl}`);
  return imageUrl?.replace(regex, "");
};

export const s3removeBaseUrl = (
  imageUrl: string | undefined | null
): string | undefined => {
  if (!imageUrl) return imageUrl || "";
  const baseUrl = `${REACT_APP_S3_BASE_URL}/`;
  const regex = new RegExp(`^${baseUrl}`);
  return imageUrl?.replace(regex, "");
};

export const getImageUrl = (data: any) => {
  if (!data) return "";

  if (isArray(data)) {
    return data.length > 0 ? removeBaseUrl(data[0]) : "";
  }

  return removeBaseUrl(data);
};
